export default import.meta.ROLLUP_FILE_URL_NMVLWf4DMBUp84Fp5hzlPw;